export const subdomainVendors = ['b2b.posterxxl.de'];
